import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  Spinner,
  Table,
  Container,
  Row,
  CardHeader,
  Modal,
  ModalBody,
  Col,
} from "reactstrap";
import { deleteSubAdmin } from "store/actions/authActions";
import { updateSubAdmin } from "store/actions/authActions";
import { getSubAdmins } from "store/actions/authActions";
import { register } from "store/actions/authActions";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const AddSubAdmin = () => {
  let dispatch = useDispatch();
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [btnLoader, setBtnLoader] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditId, setIsEditId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [loader, setLoader] = useState({
    btn: false,
    data: false,
    loadMore: false,
  });

  const infoPoints = [
    "To manage tasks more efficiently, the admin can create multiple sub-admin accounts and assign them specific permissions. Once a sub-admin has completed their duties, the admin also has the option to delete their account.",
  ];
  const subPoints = [];
  const infoTitle = "Add SubAdmin Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  const toggleModal = (edit) => {
    setAddModal(!addModal);
    if (!edit) {
      reSetPermissions();
      setUserData({
        name: "",
        email: "",
        password: "",
      });
    }
  };

  const [permissions, setPermissions] = useState({
    business: false,
    players: false,
    fans: false,
    "contract-requests": false,
    "contact-schools": false,
    schools: false,
    collectives: false,
    "approved-schools": false,
    "institute-requests": false,
    duties: false,
    manager: false,
    blogs: false,
    "admin-education": false,
    complaints: false,
    orders: false,
    "a4b-chat": false,
    resolution: false,
    "chat-ratings": false,
    "additional-earnings": false,
    "add-sub-admin": false,
    "request-cities": false,
    "request-sports": false,
    "topic-chats": false,
    "athlete-calculate": false,
    refunds: false,
    "a4b-suggestion-box": false,
    "reset-athlete-summary": false,
    context: false,
    vendors: false,
    bids: false,
  });

  const { subAdmin, hasMoreAdmin, subAdminLastDocument } = useSelector(
    (state) => state.auth
  );
  useEffect(() => {
    dispatch(getSubAdmins("", () => {}));
  }, []);
  const reSetPermissions = () => {
    setPermissions({
      business: false,
      players: false,
      fans: false,
      "contract-requests": false,
      "contact-schools": false,
      schools: false,
      collectives: false,
      "approved-schools": false,
      "institute-requests": false,
      duties: false,
      manager: false,
      blogs: false,
      "admin-education": false,
      complaints: false,
      orders: false,
      "a4b-chat": false,
      resolution: false,
      "chat-ratings": false,
      "additional-earnings": false,
      "add-sub-admin": false,
      "request-cities": false,
      "request-sports": false,
      "topic-chats": false,
      "athlete-calculate": false,
      refunds: false,
      "a4b-suggestion-box": false,
      "reset-athlete-summary": false,
      context: false,
      vendors: false,
      bids: false,
    });
  };
  const pageNames = {
    business: "Dashboard Business",
    players: "Athletes",
    fans: "Fans",
    "contract-requests": "Contracts",
    "contact-schools": "Contact Schools",
    schools: "Schools",
    collectives: "Collectives",
    "approved-schools": "Approved Schools",
    "institute-requests": "Institute Request",
    duties: "Admin Duties",
    manager: "Manager",
    blogs: "News",
    "admin-education": "Admin Education",
    complaints: "Issues",
    orders: "Orders",
    "a4b-chat": "A4B Chats",
    resolution: "Resolution",
    "chat-ratings": "Chat Ratings",
    "additional-earnings": "Additional Earnings",
    "add-sub-admin": "Add Sub Admin",
    "request-cities": "City Requests",
    "request-sports": "Sport Requests",
    "topic-chats": "Topics Chats",
    "athlete-calculate": "ADMIN Yearly Earning",
    refunds: "Refunds",
    "a4b-suggestion-box": "A4B Suggestion Box",
    "reset-athlete-summary": "Reset Athlete Summary",
    context: "Contest",
    vendors: "Vendors",
    bids: "Bids",
  };
  const handleCheckboxChange = (key, isChecked) => {
    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [key]: isChecked,
    }));
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newData = {
      ...userData,
      permissions: permissions,
    };
    setBtnLoader(true);
    dispatch(
      register(newData, (res) => {
        dispatch(getSubAdmins("", () => {}));
        setBtnLoader(false);
        if (res !== "error") {
          setUserData({
            name: "",
            email: "",
            password: "",
          });
          reSetPermissions();
          toggleModal(false);
        }
      })
    );
  };

  const handleUpgrade = (e) => {
    e.preventDefault();
    let data = {
      name: userData.name,
      email: userData.email,
      id: isEditId,
      permissions: permissions,
    };
    setBtnLoader(true);
    dispatch(
      updateSubAdmin(data, () => {
        setBtnLoader(false);
        setUserData({
          name: "",
          email: "",
          password: "",
        });
        reSetPermissions();
        toggleModal(false);
        setIsEditId("");
        setIsEdit(false);
      })
    );
  };
  const handleLoadMore = () => {
    setLoader((prev) => ({ ...prev, loadMore: true }));
    dispatch(
      getSubAdmins(subAdminLastDocument, () => {
        setLoader((prev) => ({ ...prev, loadMore: false }));
      })
    );
  };

  const columns = ["Name", "Email", "Created At"];

  const keyMap = {
    Name: "name",
    Email: "email",
    "Created At": "createdAtFormatted",
  };

  const tableData = subAdmin?.map((item) => {
    return {
      ...item,
      id: item.id,
      createdAtFormatted: moment
        .unix(item?.createdAt?.seconds)
        .format("DD-MM-YYYY"),
    };
  });

  const renderActions = (row) => {
    return (
      <>
        <Button
          color="primary"
          size="sm"
          className="mr-2"
          onClick={() => {
            setPermissions(row.permissions);
            setUserData({
              name: row.name,
              email: row.email,
            });
            setIsEdit(true);
            setIsEditId(row.id);
            toggleModal(true);
          }}
        >
          Edit Data/Permissions
        </Button>
        <Button
          color="danger"
          size="sm"
          onClick={() => {
            deleteToggle();
            setIsEditId(row.id);
          }}
        >
          Delete
        </Button>
      </>
    );
  };

  return (
    <>
      <Header />

      <Container className="mt-2" fluid>
        <Row>
          <div className="col">
            <Card className="shadow py-2">
              <CardHeader className="border-0 d-flex flex-row flex-sm-row justify-content-end align-items-start align-items-sm-center">
                <Button
                  className="mt-sm-0 bg-primary border-0 text-white btn-sm mr-2"
                  onClick={() => {
                    toggleModal(false);
                    setIsEdit(false);
                  }}
                >
                  Add SubAdmin
                </Button>
                <h2
                  className="mb-0 text-primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => setInfoModalOpen(true)}
                >
                  <i className="fa fa-question-circle" aria-hidden="true"></i>
                </h2>
              </CardHeader>

              {loader.data ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <TableComponent
                  columns={columns}
                  data={tableData}
                  keyMap={keyMap}
                  renderActions={renderActions}
                  className="align-items-center table-flush"
                />
              )}
              {subAdmin && subAdmin?.length > 4 && (
                <div className="text-center my-4">
                  <Button
                    color="primary"
                    onClick={handleLoadMore}
                    disabled={loader.loadMore || !hasMoreAdmin}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : "Load More"}{" "}
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal
        isOpen={addModal}
        centered
        size="lg"
        toggle={() => toggleModal(false)}
      >
        <ModalBody>
          <h1 className="text-center modal-title mb-3">Add Sub Admin</h1>
          <Form onSubmit={isEdit ? handleUpgrade : handleSubmit}>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter your name"
                value={userData.name}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Enter your email"
                value={userData.email}
                onChange={handleChange}
                required
              />
            </FormGroup>
            {!isEdit && (
              <FormGroup>
                <Label for="password">Password</Label>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Enter your password"
                  value={userData.password}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            )}
            <h2>Permissions</h2>
            <Row className="px-4">
              {Object.keys(permissions)
                .sort()
                .map((key) => (
                  <Col md={6} xs={12} key={key} className="">
                    <FormGroup className="mb-1" key={key}>
                      <Input
                        type="checkbox"
                        name={key}
                        checked={permissions[key]}
                        onChange={(e) =>
                          handleCheckboxChange(key, e.target.checked)
                        }
                      />
                      <Label>{pageNames[key]}</Label>
                    </FormGroup>
                  </Col>
                ))}
            </Row>
            <div className="text-right mt-2">
              <Button color="primary">
                {btnLoader ? (
                  <Spinner size="sm" />
                ) : isEdit ? (
                  "Upgrade"
                ) : (
                  "Submit"
                )}
              </Button>
              <Button color="danger" onClick={() => toggleModal(false)}>
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={deleteModal} centered toggle={deleteToggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to delete.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={() => {
                setBtnLoader(true);
                dispatch(
                  deleteSubAdmin(isEditId, () => {
                    dispatch(getSubAdmins("", () => {}));
                    setBtnLoader(false);
                    deleteToggle();
                  })
                );
              }}
              disabled={btnLoader}
            >
              {btnLoader ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={deleteToggle}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddSubAdmin;
